<template>
<div class="index" ref="viewBox">
    <!-- 轮播图 -->
    <IndexBanner></IndexBanner>
    <section class="index-content">
        <!-- <section class="jump">
            <div class="float-left jump-card">
                <p class="name color-409eff">课程分类</p>
                <div class="jump-content">
                    <span v-for="item in typeList" :key="item.code" @click="gotoSearch(1,item.code)">{{item.name}}</span>
                </div>
            </div>
            <div class="float-left jump-card">
                <p class="name color-f85757">题库分类</p>
                <div class="jump-content">
                    <span v-for="item in gjc" :key="item.code" @click="gotoSearch(2,item.code)">{{item.name}}</span>
                </div>
            </div>
            <div class="float-left other">
                <div @click="gotoAdvertisement('http://www.capwhale.com/')">
                    <img src="~common/images/index/icon-news.png" alt="资鲸网">
                    <p class="color-409eff">资鲸网</p>
                </div>
                <div @click="gotoAdvertisement('http://hd.capwhale.com/')">
                    <img src="~common/images/index/icon-active.png" alt="资鲸活动">
                    <p class="color-f85757">资鲸活动</p>
                </div>
                <div @click="gotoAdvertisement('http://report.capwhale.com/reportindex', 2)">
                    <img src="~common/images/index/icon-presentation.png" alt="资鲸投研">
                    <p class="color-fa944a">资鲸投研</p>
                </div>
            </div>
        </section> -->
        <!-- 分类跳转 -->
        <!-- 快速入口 -->
        <ClassifiedRecommendation></ClassifiedRecommendation>
        <!-- 为你推荐-->
        <courseRecommend></courseRecommend>
        <!-- 畅销好课 -->
        <section>
            <h2>畅销好课<span class="float-right more-curriculum" @click="gotoAllSearch()">更多课程</span></h2>
            <div>
                <SellWell :ruletype="1"></SellWell>
            </div>
        </section>
        <!-- 好评推荐 -->
        <section>
            <h2>好评推荐<span class="float-right more-curriculum" @click="gotoAllSearch()">更多课程</span></h2>
            <div>
                <LoveRecommend :ruletype="2"></LoveRecommend>
            </div>
        </section>
        <!-- 广告 -->
        <aside class="advertisement" v-if="advertisementListOne" @click="gotoAdvertisement(advertisementListOne.clickurl)">
            <img v-lazy="advertisementListOne.adurl" :alt="advertisementListOne.adtitle">
        </aside>
        <!-- 免费好课 -->
        <section class="free">
            <h2>免费好课<span class="float-right more-curriculum" @click="gotoAllSearch('free')">更多课程</span></h2>
            <div>
                <SellWell :ruletype="3"></SellWell>
            </div>
        </section>
        <!-- 广告 -->
        <aside class="advertisement" v-if="advertisementListTwo" @click="gotoAdvertisement(advertisementListOne.clickurl)">
            <img v-lazy="advertisementListTwo.adurl" :alt="advertisementListTwo.adtitle">
        </aside>
        <!-- 猜你喜欢 -->
        <section>
            <h2>猜你喜欢<span class="float-right more-curriculum" @click="gotoAllSearch()">更多课程</span></h2>
            <div>
                <LoveRecommend :ruletype="4"></LoveRecommend>
            </div>
        </section>
    </section>
    <Jbg ref="jbgPopu"></Jbg>
    <Agreement ref='agreementPopu'></Agreement>
    <InterestPopu  ref="interestPopu"></InterestPopu>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getAdConfig} from 'api/systemApi'
import IndexBanner from './components/banner20210315.vue'
import CourseRecommend from './components/courseRecommend.vue'
import ClassifiedRecommendation from './components/classifiedRecommendation.vue'
import LoveRecommend from './components/loveRecommend.vue'
import Agreement from './components/agreement.vue'
import Jbg from './components/jbgQrcode.vue'
import InterestPopu from './components/interestPopu.vue'
import SellWell from './components/sellWell.vue'
import Cookies from 'js-cookie'
import $ from 'jquery'
export default {
    name: 'index',
    metaInfo: {
        // title: '首页', // set a title
        meta: [{                 // set meta
        name: 'keyWords',
            content: '首页关键字内容'
        }],
        link: [{                 // set link
            rel: 'asstes',
            href: 'Homehttps://aaaaaaaaaaa/'
        }]
    },
    data() {
        return {
            typeList: [{name: '资本运营', code: '01'},{name: '金融考证', code: '02'},{name: '财税', code: '03'},{name: '投资理财', code: '04'},{name: '商业管理', code: '05'},{name: '创业创新', code: '06'}],
            gjc: [{name: '基金从业', code: '57'},{name: '期货从业', code: '55'},{name: '管理会计CMA', code: '58'},{name: '注册会计CPA', code: '59'},{name: '证券从业', code: '53'},{name: '董秘考证', code: '60'},{name: '税务师', code: '61'}],
            dialogVisible: true,
            advertisementListOne: [],  // 广告
            advertisementListTwo: [],  // 广告2
            agreementCookie: Cookies.get('agreementCookie'), // 隐私协议cookie
            isShowAgreePop:false,
            isShowInterestPop:false
        }
    },
    created() {
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MHome'
            })
        }
    },
    mounted() {
        // 判断是否登录，未登录情况下调用隐私和兴趣爱好弹窗
        //20210107去掉这个弹窗选择
        // if (this.user.isLogin == false) {
        //     // 判断是否有隐私协议
        //     let agreementCookie = this.agreementCookie
        //     // console.log('session',parseInt(sessionStorage.getItem('closeInteresPopu')) !== 1)
        //     if (agreementCookie && agreementCookie == 1) {
        //         // 隐私协议存在 调用兴趣爱好            
        //         // 判断兴趣爱好状态，不存在则调用 或用户本次关闭
        //         if (parseInt(Cookies.get('closeInteresPopu')) !== 1) {
        //             if (!Cookies.get('codelist') || Cookies.get('codelist').length == 0) {
        //                 this.isShowInterestPop=true
        //                 this.getInterestPopu()
        //             }
        //         }
        //     } else {
        //         // 不存在。调用使用协议
        //         this.isShowAgreePop=true
        //         this.$refs.agreementPopu.startPopu()
        //     }
        // }
        // 导航控制
        this.navController()
        // 广告
        this.advertisement()
    },
    methods: {
        getInterestPopu() {
            // 唤起兴趣爱好弹窗
            this.$refs.interestPopu.startPopu()
        },
        gotoAdvertisement(clickurl, type) { // 广告跳转
            if (type) {
                if (this.user.loginToken) {
                    window.open(clickurl + '?token=' + this.user.loginToken)
                } else {
                    window.open(clickurl)
                }
            } else {
                window.open(clickurl)
            }
        },
        gotoSearch(type, code) { // 根据搜索条件前往搜索页面
            if (type == 2) {
                this.$router.push({name: 'QuestionSearch', query: {catecode: code}})
            } else {
                this.$router.push({name: 'Search', query: {catecode: code}})
            }
        },
        gotoAllSearch(types) { // 前往搜索全部页面
            if (types == 'free') {
                this.$router.push({name: 'Search',query: {feetype: 1}})
            } else {
                this.$router.push({name: 'Search'})
            }
        },
        // 导航栏控制
        navController() {
            // 判断是否为index 页面
            let pageName = this.$router.history.current.name
            if (pageName === "Index") {
                $(".PHome .header").addClass("index_top_header")
                window.addEventListener('scroll',this.handleScroll)
            }
        },
        handleScroll() {
            let pageName = this.$router.history.current.name
            if (pageName === "Index") {
                // 取得滚轮所在位置
                let scroll = document.documentElement.scrollTop || document.body.scrollTop
                // 取得banner高度
                    //    let bannerHeight = $('.banner-img').height()
                    let bannerHeight = 80
                    // console.log(scroll +">" +bannerHeight)
                if (scroll > bannerHeight) {
                    $(".PHome .header").removeClass("index_top_header")
                } else {
                    $(".PHome .header").addClass("index_top_header")
                }
            }
        },
        // 广告接口
        advertisement() {
            this.setLoading(true)
            getAdConfig({
                data: {adcode: "N02"},
                success: data=> {
                    this.setLoading(false)
                    this.advertisementListOne = data.data.content[0]
                    // console.log('getAdConfig',data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            getAdConfig({
                data: {adcode: "N03"},
                success: data=> {
                    this.setLoading(false)
                    this.advertisementListTwo = data.data.content[0]
                    // console.log('getAdConfig',data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        qrcode() {  // 开启鲸报告弹窗二维码
           this.$refs.jbgPopu.qrcode()
        },
        ...mapActions([
            'setLoading'
        ])
    }, 
    filters: {},
    watch: {
        userLoginStatus(newVal, oldVal) {
            this.loginstatus = this.user.isLogin
            if (newVal != oldVal) {
                if (this.user.isLogin) {
                    // 登录成功刷新页面
                    setTimeout(() => {
                        location.reload()
                    },300)
                }
            }
        },
        agreementCookieStatus() {
            this.agreementCookie = Cookies.get('agreementCookie')
        }
    },
    computed: {
        userLoginStatus() {
            return this.user.isLogin
        },
        userLoginToken() {
            return this.user.loginToken
        },
        agreementCookieStatus() {
            return Cookies.get('agreementCookie')
        },
        ...mapGetters(['user','domainInfo'])
    },
    destroyed() {
        // console.log('销毁')
        // $(".PHome .header").removeClass("index_top_header")
    },
    components: {
        IndexBanner,
        ClassifiedRecommendation,
        SellWell,
        LoveRecommend,
        Agreement,
        InterestPopu,
        Jbg,
        CourseRecommend
    }
}
</script>

<style lang="scss" type="text/scss">
body.el-popup-parent--hidden {
    overflow: auto !important;
}
.index {
    min-width: 1200px;
    h2 {
        margin: 30px 0;
        font-size: 24px;
    }

    .more-curriculum {
        // position: relative;
        padding-right: 16px;
        line-height: 24px;
        font-size: 14px;
        color: #999999;
        cursor: pointer;
        background: url("../../../common/images/index/icon-more.png") no-repeat;
        background-size: 12px;
        background-position-y: center;
        background-position-x: right;
    }

    .advertisement {
        width: 1180px;
        height: 110px;
        cursor: pointer;
        overflow: hidden;
        background: #e5e5e5;
        
        img {
            width: 100%;
            height: 100%;
        }
    }

    .index-content {
        margin: auto;
        width: 1180px;
    }

    .jump {
        margin-top: 30px;
        overflow: hidden;

        .color-409eff {
            color: #409EFF;
        }
        .color-f85757 {
            color: #F85757;
        }
        .color-fa944a {
            color: #FA944A;
        }
        

        .jump-card {
            margin-right: 20px;
            padding: 10px;
            padding-top: 15px;
            width: 445px;
            height:95px;
            background:rgba(248,247,247,1);
            border-radius:4px;
            box-sizing: border-box;

            .name {
                font-size: 16px;
                font-weight: bold;
            }

            .jump-content {
                span {
                    display: inline-block;
                    margin-top: 10px;
                    margin-right: 16px;
                    color: #666;
                    font-size: 14px;
                    cursor: pointer;

                    &:hover {
                        color: #409EFF;
                    }
                }
            }
        }

        .other {
            margin-left: 10px;
            width: 227px;

            img {
                margin: auto;
                margin-top: 15px;
                margin-bottom: 4px;
                width: 38px;
                height: 38px;
            }
           
            div {
                margin-right: 35px;
                float: left;
                cursor: pointer;

                &:last-child {
                    margin-right: 0
                }

                p {
                    font-weight: bold;
                }
            }
    
        }
    }

    .free {
        .text_participant {
            float: left;
        }
        .text_money {
            display: none;
        }
        .nums {
            display: none;
        }
    }
}
</style>